import React from 'react';
import PropTypes from 'prop-types';
import SourceIdLink from '../../Molecules/SourceIdLink';
import { testAttributes, compProps } from './Constants';
import * as CSS from './LegalLink.module.scss';

const LegalLink = ({ legaleseMenu = compProps }) => (
    <div data-testid={testAttributes.LINK_CONTAINER} className={CSS.listWrapper}>
        <ul className={CSS.listContainer} data-testid={testAttributes.LINK_GROUP}>
            {legaleseMenu?.map(item => (
                <li data-testid={`${testAttributes.LINK_ITEM}${item.databaseId}`} itemProp="name" key={item.databaseId} className={CSS.listItem}>
                    <SourceIdLink itemProp="url" href={item.path}>
                        <span itemProp="name">{item.label}</span>
                    </SourceIdLink>
                </li>
            ))}
        </ul>
    </div>
);

LegalLink.propTypes = {
    /** legaleseMenu. List of menu items */
    legaleseMenu: PropTypes.array,
};

export default LegalLink;